import * as React from 'react';
import { Spinner } from 'components/Spinner';
import { prerenderedLoadable } from 'utils/prefetch';
const TermsConditionsPage = prerenderedLoadable(() => import(/* webpackChunkName: "TermsConditions" */ 'containers/Content/TermsConditions/TermsConditions'));
export const TermsConditions = () => (React.createElement(React.Suspense, { fallback: React.createElement(Spinner, null) },
    React.createElement(TermsConditionsPage, null)));
